import axios from "axios";

// const localURL = "http://localhost:3006/";
// const cloudURL = "https://node-ticycles-warranty.vercel.app/";
// const cloudURL = "http://ec2-34-204-214-175.compute-1.amazonaws.com:3010/"
const cloudURL = "https://backend.feostech.com/"
export const APICall = axios.create({
  baseURL: cloudURL,
  timeout: 10000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json", // Default Content-Type
  },
});
